import { CheckCircle, File, Trash } from '@phosphor-icons/react';
import React from 'react';

const FileComponent = ({ file, onDelete, className }) => {
  const fileName = file?.name || '';
  return (
    <div
      className={`w-full max-w-full overflow-hidden flex items-center justify-between gap-3 border border-grey-30 rounded-lg ${className}`}
    >
      <div className="flex items-center gap-3 min-w-0 flex-1">
        <div className="bg-grey-10 items-center rounded-full p-2">
          <File size={16} />{' '}
        </div>
        <span className="mt-1 flex-1 min-w-0 overflow-hidden text-ellipsis whitespace-nowrap">{fileName}</span>
        <Trash size={16}
          onClick={()=>onDelete()}
          className="mt-2 shrink-0" />
      </div>
      <div className="shrink-0">
        <CheckCircle size={24}
          color={'#009D64'}
          weight={'fill'} />
      </div>
    </div>
  );
};

export default FileComponent;
